$(function () {
  const accordion =  $( ".accordion-function" );
  const icons = {
    header: "customicon-chevron",
    activeHeader: "customicon-chevron active"
  };
  accordion.removeClass("accordion-function").accordion({
    collapsible: true,
    icons: icons,
    active: false,
    heightStyle: "content"
  });
  $( "#toggle" ).button().on( "click", function() {
    if ( accordion.accordion( "option", "icons" ) ) {
      accordion.accordion( "option", "icons", null );
    } else {
      accordion.accordion( "option", "icons", icons );
    }
  });
});
